import React,{useState} from "react";

import { FacturacionNru } from './FacturacionNru';

const titulo = "Servicio de facturación en línea del tramo carretero Guadalajara - Colima";
export const FacturacionConRegistro = () =>{
    const [autenticado]=useState(true);
    const urlConsultaUsoCfdi='usocfdi40/obtener_usoscfdi_por_rfc_registro.json';
    const urlConsultaRegimen="regimen/registro_obtener_por_usocfdi_rfc.json";   
    const urlValidacionNru='cruce/validarCruceRegistro.json';
    const urlConsultaNru='cruce/buscarCrucesRegistro.json';
    const urlEliminarCruces='cruce/eliminarCruceRegistro.json';
    const urlGenerarFactura='cruce/generarFacturaRegistro.json';
    const urlValicacionReceptor='receptor/validacion/validar_receptor40.json';
    const urlDescargaArchivos ='documentos/cfdi/descargazip.json';
    return (<div>
        <div className="p-fluid">
           <FacturacionNru titulo={titulo} urlConsultaUsoCfdi={urlConsultaUsoCfdi}
           urlConsultaRegimen={urlConsultaRegimen} urlValidacionNru={urlValidacionNru} urlConsultaNru={urlConsultaNru}
           autenticado={autenticado} urlEliminarCruces={urlEliminarCruces} urlGenerarFactura={urlGenerarFactura}
           urlValicacionReceptor={urlValicacionReceptor} urlDescargaArchivos={urlDescargaArchivos}/>
        </div>
    </div>);
}